import { SignIn, SignUp } from "@clerk/react";
import { Logo } from "@/components/Logo";

const Layout = ({ children }) => (
  <main className="min-h-[calc(100vh-4rem)] grid lg:grid-cols-2 bg-[#0d1b1e]">
    <aside className="hidden lg:flex relative overflow-hidden bg-[#0a1f18] grain flex-col justify-between p-12 border-r border-[#1b3d30]">
      <div className="absolute inset-0 grid-mask" />
      <div className="relative"><Logo testId="auth-logo" /></div>
      <div className="relative">
        <h2 className="text-4xl font-extrabold text-white leading-tight">Simbiosis industrial, <span className="text-[#00f2a1]">trazable</span> y rentable.</h2>
        <p className="text-slate-400 mt-4 max-w-md">Publica lotes, oferta en subastas rápidas y obtén certificados de valorización y CO₂.</p>
      </div>
      <p className="relative font-mono text-xs text-slate-500">terraloop.cl</p>
    </aside>
    <div className="flex items-center justify-center px-4 py-12">{children}</div>
  </main>
);

export const SignInPage = () => (
  <Layout><div data-testid="sign-in-page"><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" /></div></Layout>
);

export const SignUpPage = () => (
  <Layout><div data-testid="sign-up-page"><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" /></div></Layout>
);
